import React from "react";
const AboutUs = () => {
  return (
    <>
      <div className="bg-white text-gray-800 flex flex-col gap-[60px] items-start lg:items-end justify-between pb-24 w-full">
        <section className="bg-[#f1edfc] w-full pt-12 md:px-20 px-4">
          <div className="container flex flex-col lg:flex-row items-start justify-between">
            <div className="lg:w-1/2 w-full mb-8 lg:mb-0">
              <h2 className="font-bold mb-6">
                Your health, your safety — one card for confidence and protection in any situation.
              </h2>
              <p className="text-gray-900 text-base leading-relaxed mb-6">
                Project Sunflower Lanyard is designed to give people with chronic illnesses, invisible and visible disabilities a simple, reliable way to stay safe in emergencies. Tailored for India’s healthcare system, it combines awareness, education, and technology to fill a long-overlooked gap. With an NFC-enabled medical emergency card, it ensures that help is just a tap away — offering independence, dignity, and peace of mind whether at home, while traveling, or in public spaces.
              </p>
            </div>

            <div className="lg:w-2/3 w-full flex justify-center lg:justify-end relative top-[60px] md:top-[60px] lg:top-[100px]">
              <img
                src={"/Assets/Images/AboutUsBanner.png"}
                alt="People with disabilities illustration"
                className="object-contain"
              />
            </div>
          </div>
        </section>

        <section className="bg-white mx-4 py-16 md:px-20 md:mx-0">
          <div>
            <div className="grid grid-cols-1 md:grid-cols-12 gap-6 items-start">
              <div className="col-span-4">
                <h2 className="text-2xl md:text-3xl font-bold m-0">
                  Our Vision
                  <br />& Mission
                </h2>
              </div>
              <div className="col-span-8 grid grid-cols-12 gap-4 items-start lg:px-24">
                {/* Vision Box */}
                <div className="bg-[#f1edfc] p-6 rounded-xl shadow-sm h-full col-span-12">
                  <div className="flex items-start gap-4">
                    <div className="text-purple-600 w-12 h-12 md:w-14 md:h-14 lg:w-16 lg:h-16 flex items-center justify-center">
                      <img
                        src="/Assets/Images/Vision.svg"
                        alt="Vision"
                        className="w-10 h-10 md:w-12 md:h-12 lg:w-14 lg:h-14 object-contain"
                      />
                    </div>
                    <div>
                      <p className="font-bold">
                        A world where every person with a disability can live independently, safely, and with dignity, without barriers or fear during daily life or travel.
                      </p>
                      <h3 className="mt-4">
                        <span className="inline-block text-purple-700 border border-purple-700 rounded-md px-4 py-1 text-sm font-medium bg-[#f1edfc]">
                          Vision
                        </span>
                      </h3>
                    </div>
                  </div>
                </div>

                {/* Mission Box */}
                <div className="bg-[#f1edfc] p-6 rounded-xl shadow-sm col-span-12">
                  <div className="flex items-start gap-4">
                    <div className="text-purple-600 w-12 h-12 md:w-14 md:h-14 lg:w-16 lg:h-16 flex items-center justify-center">
                      <img
                        src="/Assets/Images/MissionIcon.svg"
                        alt="Mission"
                        className="w-10 h-10 md:w-12 md:h-12 lg:w-14 lg:h-14 object-contain"
                      />
                    </div>
                    <div>
                      <h3 className="mb-4">
                        <span className="inline-block text-purple-700 border border-purple-700 rounded-md px-4 py-1 text-sm font-medium bg-[#f1edfc]">
                          Mission
                        </span>
                      </h3>
                      <ul className="text-sm text-gray-700 list-disc pl-5 space-y-2">
                        <li>To ensure every person with a disability feels safe, secure, and supported in their daily life.</li>
                        <li>To raise awareness and educate communities, caregivers, and responders about invisible and chronic disabilities.</li>
                        <li>To build an inclusive medical emergency ecosystem that empowers individuals to live independently and confidently.</li>
                        <li>To support children and adults with invisible and physical disabilities by improving visibility and safety in public spaces.</li>
                        <li>To reduce the stigma and discrimination faced by people with invisible and chronic disabilities.</li>
                        <li>To create a culture of empathy and preparedness, ensuring society understands and respects diverse needs.</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default AboutUs;
